<template>
  <ol class="f-col gap-6">
    <li v-for="({ heading, text }, i) in items" :key="`item-${i}`">
      <div class="flex gap-4">
        <div class="mt-1 h-8 w-8 flex shrink-0 center rounded-full bg-brand-4 c-white">
          <span class="title-3">{{ i + 1 }}</span>
        </div>
        <div>
          <div class="overline-1 subtitle-2">
            {{ heading }}
          </div>
          <p class="body-2">
            {{ text }}
          </p>
        </div>
      </div>
    </li>
  </ol>
</template>

<script lang="ts" setup>
defineProps<{
  items: {
    heading: string
    text: string
  }[]
}>()
</script>
